export default __webpack_public_path__ + "static/media/dsAppBG.5552e35b.png";